(function ($) {
  $(document).ready(function () {

    // footer
    addTargetFooter();
    translateTabsProduct();

    function addTargetFooter() {
      const linkFooter = $('.footer .container .menu_links .footer__link a');
      linkFooter.map(function (index, ele) {
        const href = $(ele).attr('href');
        if (href.indexOf('.sony.com.vn') > -1) {
          $(ele).attr('target', '_blank');
        }
      })
    }

    // translate Tabs product
    function translateTabsProduct() {
      if ($('.template-product').length) {
        const translate_product_tabs = window.theme.translate_product_tabs;
        $('.product__tabs .tabs__content-item .pdp-tab-title').map(function (i, ele) {
          let title = $(ele).text().trim().toLowerCase();
          Object.keys(translate_product_tabs).forEach(key => {
            if(key === title){
              title = translate_product_tabs[key];
            }
          });
          $(ele).text(title);
        })

        $('.product__tabs .tabs__nav .tabs__nav-item').map(function (i, ele) {
          let title = $(ele).text().trim().toLowerCase();
          Object.keys(translate_product_tabs).forEach(key => {
            if(key === title){
              title = translate_product_tabs[key];
            }
          });
          $(ele).text(title);
        })
      }
    };

  })
}(jQuery));
